<template>
  <ul class="breadcrumbs-wrap">
    <li class="breadcrumb-item"><a href="https://www.sunsim.ru/">Главная</a></li>
    <li class="breadcrumb-item"><a href="https://cabinet.sunsim.ru/">Войти</a></li>
    <li class="breadcrumb-item">{{ current }}</li>
  </ul>
</template>

<script>
export default {
  name: "BreadCrumbs",
  props: {
    current: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="less">

.breadcrumbs-wrap {
  list-style-type: none;
  margin: 0;
  padding: 0;
  .breadcrumb-item {
    font-size: 12px;
    color: #adadad;
    display: inline-block;
    &::before {
      content: '/';
      margin-right: 3px;
    }
    &:first-child {
      &::before {
        content: none;
      }
    }
    a {
      color: #666;
    }
  }
}

</style>